import { createFileRoute, notFound, type SearchSchemaInput } from '@tanstack/react-router';
import { canUseMockMode } from '@/lib/mock-mode';
import { DraperAdminPage } from '@/features/admin/draper/draper-admin-page';

const positive = (value: unknown): number | undefined => {
  const n = typeof value === 'number' ? value : typeof value === 'string' ? Number(value) : NaN;
  return Number.isInteger(n) && n > 0 ? n : undefined;
};

// Dreamwell staff only: anyone else gets the not-found page (the API refuses them too). `teamId` acts on another team
// than the staff member's own; `run` opens one of its runs (a failure listed under "Every team" links both). The values
// are read in the component, which is split from the entry (the validator ships in it, so it only passes them on).
export const Route = createFileRoute('/_authed/admin/draper')({
  validateSearch: (search: { teamId?: unknown; run?: unknown } & SearchSchemaInput) => search as { teamId?: unknown; run?: unknown },
  beforeLoad: ({ context: { user } }) => {
    if (!canUseMockMode(user.email)) throw notFound();
  },
  component: DraperAdminRoute,
});

function DraperAdminRoute() {
  const { team } = Route.useRouteContext();
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  if (!team) return null;
  const shown = positive(search.teamId) ?? team.id;
  const run = positive(search.run);
  return (
    <DraperAdminPage
      key={shown}
      teamId={shown}
      ownTeamId={team.id}
      initialRunId={run ?? null}
      onOpen={(next, nextRun) => void navigate({ search: { ...(next === team.id ? {} : { teamId: next }), ...(nextRun ? { run: nextRun } : {}) } })}
    />
  );
}
